jQuery(document).ready(function(){
  "use strict";  
  var initializeCollectionHeading = function(){
    var featuedCollections =  jQuery('[data-ele="featued-collection"]');
    if(featuedCollections && typeof featuedCollections != 'undefined' && featuedCollections.length){
      var collectionStickyContainer = '<div data-ele="collections-sticky-header" class="collections-sticky-header color-background-2"><div class="page-width" data-ele="collection-sticky"><div data-ele="collection-sticky-inner"></div></div></div>';
      jQuery('#shopify-section-header').append(collectionStickyContainer);
      featuedCollections.each(function(index, value) {
        var _this = jQuery(this);
        var sectionId = _this.attr('data-section-id');
        var _title = _this.find('[data-ele="section-title"]').text();
        jQuery('[data-ele="collection-sticky-inner"]').append('<span section-id="'+sectionId+'" data-ele="section-heading" class="section-heading section-seading">'+_title+'</span>');
      });
    }
  }

  jQuery(window).on("load scroll", function () {
    var winScrollTop = jQuery(window).scrollTop(), 
      domHeight = jQuery('body').height(),
      winHeight = jQuery(window).innerHeight(),
      elements = jQuery('[data-ele="featued-collection"]');
      //elements = jQuery('[data-ele="featued-collection"]');
      
      elements.each(function(index, element){
        var element = jQuery(element);
        var elementOffesetTop = element.offset().top;
        var elementOffesetBottom = elementOffesetTop + element.height();
        
        if(((winScrollTop + winHeight/2) > elementOffesetTop) && (winScrollTop < elementOffesetBottom)){
          var title = element.find('[data-ele="section-title"]').text();
          var dataSectionId = element.attr('data-section-id');
          jQuery('[data-ele="collection-sticky"] [data-ele="section-heading"]').removeClass('section-active');
          jQuery('[data-ele="collection-sticky"] [section-id="'+dataSectionId+'"]').addClass('section-active');
          jQuery('[data-ele="collection-sticky"]').scrollCenter(".section-active");
        }        
      });
  });

  // handle links with @href started with '#' only
  jQuery(document).on('click', '[data-ele="section-heading"]', function(e) {
      // target element id
      var stickeyHeaderHeight = jQuery('[data-ele="collections-sticky-header"]');
      var targetEle = jQuery(this).attr('section-id');
      // target element
      var targetEle = jQuery('[data-section-id="'+targetEle+'"]');
      if (targetEle.length === 0) {
          return;
      }
      // prevent standard hash navigation (avoid blinking in IE)
      e.preventDefault();
    
      // top position relative to the document
      var pos = targetEle.offset().top - stickeyHeaderHeight.outerHeight();
      // animated top scrolling
      jQuery('html').animate({scrollTop: pos},1100);
  });

  
  initializeCollectionHeading();
});





